import { AlertTriangle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

/**
 * Badge shown on games flagged as "Achievement Slop" in the MDB.
 * Uses a warning-icon pill with hover text explaining what the flag means.
 * Rendered in the game header, Library card, and Browse tile.
 */
export function SlopBadge({ compact = false, className = "" }) {
  const label = compact ? "Slop" : "Achievement Slop";
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid="achievement-slop-badge"
            className={
              "inline-flex items-center gap-1 rounded-full border border-amber-500/40 bg-amber-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-300 " +
              className
            }
          >
            <AlertTriangle className="h-3 w-3" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs leading-relaxed">
          This game exists solely to increase achievement/trophy counts and/or
          provide score boosts. It includes numerous (over 500) easy-to-unlock
          achievements. Achievement data is not stored, notes features are
          disabled, and its achievements are excluded from Dashboard and
          Statistics counts.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default SlopBadge;
